export const title = 'Ticket médio (Gráfico)';

Evolução do ticket médio das vendas ao longo do tempo.
